import React, { useState, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "../../../../_helpers/components/Button";
const rawManifestations = [
    {
        id: 1,
        name: "Visite guidée des Grands Appartements",
        lieu: "Grands Appartements",
        statut: "Projet validé",
        statut_planification: "Programmable",
        regroupement: "VG Individuels",
        prochaine_date: "2025-07-01 10:00",
    },
    {
        id: 2,
        name: "Atelier famille : la vie à la cour",
        lieu: "Galerie des Batailles",
        statut: "Visuel à créer",
        statut_planification: "Non programmable",
        regroupement: "VG Versailles en famille",
        prochaine_date: "2025-07-03 14:30",
    },
    {
        id: 3,
        name: "Spectacle des Grandes Eaux Musicales",
        lieu: "Jardins de Versailles",
        statut: "A mettre à jour dans la billetterie",
        statut_planification: "Programmable",
        regroupement: "Évènement culturel",
        prochaine_date: "2025-07-02 15:00",
    },
    {
        id: 4,
        name: "Bal costumé à la Galerie des Glaces",
        lieu: "Galerie des Glaces",
        statut: "En cours de création",
        statut_planification: "Archivé",
        regroupement: "Projets Pour Tous",
        prochaine_date: "2025-07-07 20:00",
    },
    // ... ajoute d'autres événements si tu veux tester la pagination
];

export const ManifestationsList = () => {
    const navigate = useNavigate();

    const [filters, setFilters] = useState({
        lieu: "",
        statut: "",
        statut_planification: "",
        regroupement: "",
    });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const filtered = useMemo(() => {
        return [...rawManifestations]
            .filter((m) => new Date(m.prochaine_date) >= new Date())
            .filter((m) =>
                Object.entries(filters).every(
                    ([key, value]) => !value || m[key] === value
                )
            )
            .sort(
                (a, b) =>
                    new Date(a.prochaine_date).getTime() -
                    new Date(b.prochaine_date).getTime()
            );
    }, [filters]);

    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const paginated = filtered.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const getOptions = (key) => [
        ...new Set(rawManifestations.map((m) => m[key])),
    ];

    return (
        <div className="overflow-x-auto p-4 bg-white shadow-sm rounded-sm">
            <div className="flex justify-end mb-4">
                <button
                    onClick={() => navigate("")}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Ajouter une activité"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </button>
                <button
                    onClick={() => navigate("")}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Exporter"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
                        />
                    </svg>
                </button>
            </div>

            <div className="grid grid-cols-4 gap-4 mb-4">
                <select
                    className="border p-2 rounded-sm"
                    value={filters.lieu}
                    onChange={(e) => {
                        setFilters({ ...filters, lieu: e.target.value });
                        setCurrentPage(1);
                    }}
                >
                    <option value="">Tous les lieux</option>
                    {getOptions("lieu").map((opt) => (
                        <option key={opt}>{opt}</option>
                    ))}
                </select>
                <select
                    className="border p-2 rounded-sm"
                    value={filters.statut}
                    onChange={(e) => {
                        setFilters({ ...filters, statut: e.target.value });
                        setCurrentPage(1);
                    }}
                >
                    <option value="">Tous les statuts</option>
                    {getOptions("statut").map((opt) => (
                        <option key={opt}>{opt}</option>
                    ))}
                </select>
                <select
                    className="border p-2 rounded-sm"
                    value={filters.statut_planification}
                    onChange={(e) => {
                        setFilters({
                            ...filters,
                            statut_planification: e.target.value,
                        });
                        setCurrentPage(1);
                    }}
                >
                    <option value="">Toutes les planifications</option>
                    {getOptions("statut_planification").map((opt) => (
                        <option key={opt}>{opt}</option>
                    ))}
                </select>
                <select
                    className="border p-2 rounded-sm"
                    value={filters.regroupement}
                    onChange={(e) => {
                        setFilters({
                            ...filters,
                            regroupement: e.target.value,
                        });
                        setCurrentPage(1);
                    }}
                >
                    <option value="">Tous les regroupements</option>
                    {getOptions("regroupement").map((opt) => (
                        <option key={opt}>{opt}</option>
                    ))}
                </select>
            </div>

            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                    <tr>
                        <th className="px-6 py-3">Nom</th>
                        <th className="px-6 py-3">Lieu</th>
                        <th className="px-6 py-3">Statut</th>
                        <th className="px-6 py-3">Planification</th>
                        <th className="px-6 py-3">Regroupement</th>
                        <th className="px-6 py-3">Prochaine date</th>
                    </tr>
                </thead>
                <tbody>
                    {paginated.map((m) => (
                        <tr
                            key={m.id}
                            className="bg-white border-b cursor-pointer"
                            onClick={() =>
                                navigate("/activity/projets/fiche/" + m.id)
                            }
                        >
                            <td className="px-6 py-4 font-medium text-gray-900">
                                {m.name}
                            </td>
                            <td className="px-6 py-4">{m.lieu}</td>
                            <td className="px-6 py-4">{m.statut}</td>
                            <td className="px-6 py-4">
                                {m.statut_planification}
                            </td>
                            <td className="px-6 py-4">{m.regroupement}</td>
                            <td className="px-6 py-4">{m.prochaine_date}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination */}
            <div className="flex justify-between items-center mt-4">
                <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                    className={`px-4 py-2 rounded ${
                        currentPage === 1
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-blue-600 text-white"
                    }`}
                >
                    Précédent
                </button>

                <span className="text-sm text-gray-700">
                    Page {currentPage} sur {totalPages}
                </span>

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                    className={`px-4 py-2 rounded ${
                        currentPage === totalPages
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-blue-600 text-white"
                    }`}
                >
                    Suivant
                </button>
            </div>
        </div>
    );
};
